export default {
  actions: {
    copied: "Копирано во клипборд",
    copyFailed: "Неуспешно копирање",
    channelStarted: "{channelName} успешно е стартуван",
    channelStartFailed: "Неуспешно стартување на {channelName}",
    channelStopped: "{channelName} успешно е запрен",
    channelStopFailed: "Неуспешно запирање на {channelName}",
    cacheCleared: "Кешот на Iris Core успешно е исчистен",
    cacheClearFailed: "Неуспешно чистење на кешот на Iris Core",
  },

  tooltips: {
    copyBarcode: "Копирајте го баркодот во клипборд",
  },
};
